import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {AuthGuard} from "../auth-module/services";
import {USER_ROLES} from "../app.config";
import {DashboardPageComponent} from "./pages/dashboard-page/dashboard-page.component";

const dashboardRoutes: Routes = [
  {
    path: "dashboard",
    children: [
      {
        path: "",
        component: DashboardPageComponent
      }
    ],
    canActivate: [AuthGuard],
    data: {
      expectedRoles: [USER_ROLES.sales_floor]
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(dashboardRoutes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule {
}
